import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Rank 1 ("Sam Norris Approved") is a stealth ad: a link to the books, with a popup explaining who
// Sam Norris is. Hover reveals it on desktop; tapping the name toggles it on mobile.
const RankBadge = ({ rank }) => {
  const [open, setOpen] = useState(false);

  if (!rank.isLink || !rank.linkUrl) {
    return <strong>{rank.name}</strong>;
  }

  return (
    <span className="cf-rank-badge">
      <Link to={rank.linkUrl} className="cf-rank-link" onClick={(event) => { event.preventDefault(); setOpen(!open); }}>
        <strong>{rank.name}</strong>
      </Link>
      {rank.popupText && (
        <span className={`cf-rank-popup ${open ? 'open' : ''}`}>
          {rank.popupText}{' '}
          <Link to={rank.linkUrl} className="cf-rank-popup-go">Take me there →</Link>
        </span>
      )}
    </span>
  );
};

export default RankBadge;
